var exports = {
  "y": "help-RGR2N",
  "r": "topMenu-RGR2N",
};

module.exports = exports;
